export const educationData = [
  {
    id: 1,
    institution: 'Sardar Vallabhbhai National Institute of Technology',
    degree: 'Bachelor of Technology',
    course: 'Computer Science and Engineering',
    startYear: '2019',
    endYear: '2023',
    gpa: '7.44 CGPA',
  },
];
